var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSign20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.062 13.444s.92.82 2.732 1.05c5.619.708 4.268-8.43-.89-9.566-1.842 4.426 6.085 11.252 9.464 9.984 1.93-.724 2.9-3.34 1.362-5.098-1.538-1.758-2.77-1.202-2.879-1.12-.3.221-.691 2.399 2.106 4.177 1.787 1.136 3.981 1.118 3.981 1.118",
  stroke: "#000",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgSign20;